module.exports = __webpack_public_path__ + "static/media/ferda.b13e4f17.jpg";